import * as React from 'react';
import { Button } from 'antd';
import { UpSquareFilled, DownSquareFilled, CloseOutlined } from '@ant-design/icons';

import './style.scss';

interface IProductLineProps {
    variant: GQL.IProductVariant;
    language?: string;
    moveUp: () => void;
    moveDown: () => void;
    onDelete: () => void;
    disabledUp?: boolean;
    disabledDown?: boolean;
}

export class ProductLine extends React.PureComponent<IProductLineProps> {
    render(): React.ReactNode {
        const { variant, moveUp, moveDown, onDelete, language, disabledUp, disabledDown } = this.props;
        if (!variant.product) {
            return null;
        }

        return <div className='recommended-product-line'>
            <div className="recommended-product-line__product">
                <b>
                    {language && variant.product.name[language] || variant.product.title}
                </b>
                <br />
                Item number: {variant.ean}
            </div>
            <Button onClick={() => moveUp()} disabled={disabledUp}><UpSquareFilled /></Button>
            <Button onClick={moveDown} disabled={disabledDown}><DownSquareFilled /></Button>
            <Button onClick={onDelete}><CloseOutlined /></Button>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/RecommendedProductsTab/ProductLine/ProductLine.tsx